module.exports = __webpack_public_path__ + "img/fi-rr-time-add.b27bc3c2.svg";